"use client";

import { useEffect, useState } from "react";

const STORAGE_KEY = "sectionsViewMode";

export function getStoredViewMode() {
  if (typeof window === "undefined") return "grid";
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === "list" ? "list" : "grid";
  } catch {
    return "grid";
  }
}

export function setStoredViewMode(mode) {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // ignore
  }
}

export default function ViewToggle({ viewMode, onViewChange, className = "" }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <div
      className={`btn-group ${className}`.trim()}
      role="group"
      aria-label="طريقة العرض"
    >
      <button
        type="button"
        className={`btn btn-sm ${viewMode === "grid" ? "btn-primary" : "btn-outline-secondary"}`}
        onClick={() => onViewChange("grid")}
        aria-pressed={viewMode === "grid"}
        title="عرض شبكي"
      >
        <i className="bi bi-grid-3x3-gap-fill" aria-hidden></i>
      </button>
      <button
        type="button"
        className={`btn btn-sm ${viewMode === "list" ? "btn-primary" : "btn-outline-secondary"}`}
        onClick={() => onViewChange("list")}
        aria-pressed={viewMode === "list"}
        title="عرض قائمة"
      >
        <i className="bi bi-list-ul" aria-hidden></i>
      </button>
    </div>
  );
}
